export default __webpack_public_path__ + "static/media/viewpasswordsprit.c6c1fb38.svg";